/**
 * FAQ Accordion Component
 *
 * Supports both:
 * - .faq-item [data-faq] (shared component pattern)
 * - .faq__item (legacy pattern)
 */

document.addEventListener('DOMContentLoaded', () => {
  // Target all FAQ items using both patterns
  const items = document.querySelectorAll('.faq-item[data-faq], .faq__item');

  items.forEach((item) => {
    const question = item.querySelector('.faq-item__question, .faq__question');
    const answer = item.querySelector('.faq-item__answer, .faq__answer');

    if (!question || !answer) return;

    question.addEventListener('click', () => {
      const isOpen = item.classList.toggle('is-open');
      question.setAttribute('aria-expanded', isOpen);

      if (answer.hasAttribute('aria-hidden')) {
        answer.setAttribute('aria-hidden', !isOpen);
      }

      if (isOpen) {
        answer.style.maxHeight = answer.scrollHeight + 'px';
        answer.addEventListener('transitionend', function handler() {
          if (item.classList.contains('is-open')) {
            answer.style.maxHeight = 'none';
          }
          answer.removeEventListener('transitionend', handler);
        });
      } else {
        answer.style.maxHeight = answer.scrollHeight + 'px';
        requestAnimationFrame(() => {
          answer.style.maxHeight = '0';
        });
      }
    });
  });
});
